import * as appState from "./ac101-app.js";
import { Tooltip } from "bootstrap";

export class AC101SearchBox extends HTMLElement {
  constructor() {
    super();
    console.log(AC101SearchBox);
  }

  get tabs() {
    return this.querySelectorAll("[data-listing-type]");
  }

  get form() {
    return this.querySelector("form");
  }

  _select = (e) => {
    for (const tab of this.tabs) {
      tab.classList.remove("search-link-label-active");
    }
    console.log("select");
    e.target.classList.add("search-link-label-active");
    appState.listingType.set(e.target.getAttribute("data-listing-type"));
  };

  connectedCallback() {
    if (this.hasAttribute("autofocus")) {
      this.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    }

    for (const tab of this.tabs) {
      console.log({ tab });
      tab.addEventListener("click", this._select);
      appState.listingType.subscribe(() => {
        if (
          tab.getAttribute("data-listing-type") == appState.listingType.get()
        ) {
          tab.classList.add("search-link-label-active");
        } else {
          tab.classList.remove("search-link-label-active");
        }
      });
    }

    appState.action.subscribe(() => {
      this.form.action = appState.action.get() ?? "";
    });

    this.tooltip = new Tooltip(this.submitButton, {
      placement: "top",
      title: "Please enter a location by postcode, suburb, region or name",
      customClass: "ac101-tooltip",
      html: true,
    });
    this.tooltip.disable();
    this.submitButton.addEventListener("pointerover", this.updateTooltip);

    this.form.addEventListener("submit", (e: SubmitEvent) => {
      if (!this.form.getAttribute("action")) {
        e.preventDefault();
      }
      const data = new FormData(this.form);
      let hasData = false;
      for (const entry of data.entries()) {
        hasData = true;
        break;
      }
      this.updateTooltip();
      if (!hasData) {
        window.location.href = this.form.getAttribute("action");
        e.preventDefault();
      }
    });

    for (const btn of this.filterButtons) {
      btn.addEventListener("click", this.openFiltersModal);
    }

    for (const select of this.listingTypeSelects) {
      select.addEventListener("change", (e) => {
        console.log(e.target.value);
        appState.listingType.set(e.target.value);
      });
      appState.listingType.subscribe(() => {
        select.value = appState.listingType.get();
      });
    }
  }

  updateTooltip = () => {
    if (!this.form.getAttribute("action")) {
      this.tooltip.enable();
      this.tooltip.show();
    } else {
      this.tooltip.hide();
      this.tooltip.disable();
    }
  };

  tooltip: Tooltip;

  get listingTypeSelects() {
    return this.querySelectorAll<HTMLSelectElement>(
      "select[data-listing-type-select]"
    );
  }

  get submitButton() {
    return this.querySelector('button[type="submit"]');
  }

  get filterButtons() {
    return this.querySelectorAll("button[data-filter-button]");
  }

  openFiltersModal = () => {
    this.dispatchEvent(
      new CustomEvent("open-filters", {
        detail: { term: appState.result.get()?.name ?? "" },
        bubbles: true,
        composed: true,
      })
    );
  };
}

customElements.define("ac101-search-box", AC101SearchBox);

declare global {
  interface HTMLElementTagNameMap {
    "ac101-search-box": AC101SearchBox;
  }
}
